import React from 'react';
import { Button } from 'components/core';
import { Icon, IconList } from 'components/core/Icon';

type Props = {
  onClick: () => void;
};

// DE2 specific "Edit template" button. Different from the DE1 button, it does not own the
// navigation logic, but instead relies on the parent component to handle it
const EditTemplateButton = ({ onClick }: Props): JSX.Element => (
  <Button onClick={onClick} variant="ghost" type="brand">
    <Icon icon={IconList.light.faPenToSquare} size="md" />
    Edit template
  </Button>
);

export default EditTemplateButton;
